import { App } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosCustomError } from 'services/http';
import { http } from 'services/http';
import { FAVORITES_GET_MANY } from 'api/query-keys';

interface ICreateFavoritesReq {
  cargoIds: number[];
  color: string;
}

export const useCreateFavorites = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: ICreateFavoritesReq) => {
      const res = await http.post(`/v1/favorites`, variables);

      return res.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries([FAVORITES_GET_MANY]);
    },

    onError: (error) => {
      const { message: errorMessage, key } = (error as AxiosCustomError)?.response?.data || {};
      message.error(errorMessage || key);
    },
  });
};
